import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';

export const AuthConfig: OpenIdConfiguration = {
  authority: environment.discoveryUrl,
  clientId: environment.helloIdClientId,
  scope: 'openid profile offline_access',
  // HelloID's registered redirect URI differs per environment: local lands on the root, test on
  // /authorize. environment.authRedirectPath carries that suffix; app.routes.ts has a matching route.
  redirectUrl: `${environment.baseUrl}${environment.authRedirectPath}`,
  postLoginRoute: '/',
  // Post-logout returns to the serving origin plus an environment-specific path (prod returns to
  // /authentication); empty elsewhere, so this stays the bare origin as before.
  postLogoutRedirectUri: `${window.location.origin}${environment.postLogoutPath}`,
  forbiddenRoute: '/forbidden',
  unauthorizedRoute: '/unauthorized',
  responseType: 'code',
  useRefreshToken: true,
  silentRenew: true,
  ignoreNonceAfterRefresh: true,
  // Disabled because HelloID's userinfo call failed mid-callback and bounced first-time logins
  // to /unauthorized (the tokens were already stored, so a refresh appeared to fix it). User
  // claims now come from the id_token (see UserService); re-enable only once HelloID userinfo works.
  autoUserInfo: false,
  logLevel: LogLevel.Warn,
  secureRoutes: environment.apiUrl ? [environment.apiUrl] : [],
};
